/* globals fetch */
import moment from 'moment';
import dataProvider from '../dataProvider';
import { encodeParams, roundToTwoDecimals } from '../helper';

export const UPDATE_EVENTS_REQUEST = 'UPDATE_EVENTS_REQUEST';
export const FETCH_RESOURCES_REQUEST = 'FETCH_RESOURCES_REQUEST';
export const FETCH_RESOURCES_SUCCESS = 'FETCH_RESOURCES_SUCCESS';
export const FETCH_RESOURCES_FAILURE = 'FETCH_RESOURCES_FAILURE';
export const UPDATE_RELOAD = 'UPDATE_RELOAD';

const formatServiceVehicle = ({ service_vehicle_id, name }) => {
  return {
    id: service_vehicle_id,
    service_vehicle_id,
    title: name,
  };
};

const fetchServiceVehicles = () => {
  return dataProvider
    .getList('service-vehicle', {
      filter: {},
      sort: { field: 'service_vehicle_id', order: 'ASC' },
      pagination: { page: 1, perPage: 100 },
    })
    .then((response) => {
      if (response && response.data) {
        return response.data.map((r) => formatServiceVehicle(r));
      }
      return null;
    });
};

const formatHoliday = (holiday) => {
  return {
    id: holiday.id,
    title: holiday.summary,
    start: holiday.start.date,
    end: holiday.end.date,
    display: 'background',
    backgroundColor: '#ff9f89',
    allDay: true,
  };
};

const fetchHolidays = (start, end) => {
  const calendarId = 'en.usa%23holiday%40group.v.calendar.google.com';
  const params = {
    key: process.env.REACT_APP_GOOGLE_CALENDAR_API_KEY,
    timeMin: moment(start).format(),
    timeMax: moment(end).format(),
    singleEvents: 'true',
    maxResults: '9999',
  };
  const url = `https://www.googleapis.com/calendar/v3/calendars/${calendarId}/events?${encodeParams(
    params,
  )}`;
  return fetch(url)
    .then((r) => r.json())
    .then((r) => (r.items ? r.items.map((i) => formatHoliday(i)) : []));
};

const formatCalendarEvent = (event) => {
  return {
    id: event.schedule_instance_id,
    title: event.service_vehicle_id,
    resourceId: event.service_vehicle_id,
    start: event.start_time,
    end: event.end_time,
    backgroundColor: 'transparent',
    display: 'block',
    borderColor: 'transparent',
    textColor: 'black',
    event,
    extendedProps: {
      scheduledWorks: event.current_scheduled_works || 0,
      scheduled_works_list: event.scheduled_works,
      limit_scheduled_works: event.limit_scheduled_works,
      limit_total_hours: event.limit_total_hours,
      limit_total_driving_hours: event.limit_total_driving_hours,
      availableHours: roundToTwoDecimals(
        (event.limit_total_hours || 0) - (event.current_total_hours || 0),
      ),
      bookedHours:
        event.current_scheduled_works > 0
          ? roundToTwoDecimals(
              (event.current_service_hours || 0) +
                (event.current_valet_hours || 0) +
                (event.buffer_time_minutes || 0) / 60,
            )
          : 0,
      transitTime: roundToTwoDecimals(event.current_transit_hours || 0),
      percent: Math.floor(
        ((event.current_total_hours || 0) / (event.limit_total_hours || 0)) *
          100,
      ),
      customer: {
        name:
          event.scheduled_works[0]?.customer_first_name ||
          `${event.scheduled_works[0]?.customer_last_name}` ||
          '',
        address: event.scheduled_works[0]?.client_location_name || '',
      },
    },
  };
};

export const fetchCalendarEvents = (start, end) => {
  return dataProvider
    .getList('schedule/stats', {
      filter: {
        start_time_after: moment(start).format(),
        end_time_before: moment(end).format(),
      },
      sort: { field: 'date', order: 'ASC' },
      pagination: { page: 1, perPage: 2000 },
    })
    .then(({ data: calendarEventData }) => {
      return fetchHolidays(start, end).then((holidaysData) => {
        if (calendarEventData) {
          const formattedCalendarEvents = calendarEventData.map((event) =>
            formatCalendarEvent(event),
          );
          return [...formattedCalendarEvents, ...holidaysData];
        }
        return holidaysData || null;
      });
    });
};

export const fetchResources = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_RESOURCES_REQUEST });
    const resources = await fetchServiceVehicles();
    if (resources) {
      dispatch({ type: FETCH_RESOURCES_SUCCESS, resources });
    } else {
      dispatch({ type: FETCH_RESOURCES_FAILURE, error: 'error' });
    }
    return Promise.resolve();
  };
};

export const updateReload = (reload) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_RELOAD, reload });
  };
};
